export default __webpack_public_path__ + "static/media/lightning-right-top.d0404b62.png";